module.exports = __webpack_public_path__ + "img/285.983b4254.jpg";